import { McpServerService } from './mcpServerService';
import { AxiosResponse } from 'axios';
import { McpServerDto, McpServerTestConnectionDto } from 'src/types/mcpServer';

export interface ApiMcpServerService {
    getMcpServers(urlParams: string): Promise<AxiosResponse>;
    getMcpServerById(id: string): Promise<AxiosResponse>;
    createMcpServer(data: McpServerDto): Promise<AxiosResponse>;
    updateMcpServer(id: string, data: McpServerDto): Promise<AxiosResponse>;
    deleteMcpServers(ids: string[]): Promise<AxiosResponse>;
    testConnection(id: string, data: McpServerTestConnectionDto): Promise<AxiosResponse>;
    getCredential(id: string): Promise<AxiosResponse>;
}

export const mcpServerService = new McpServerService();
